//@flow
import React, { useEffect, useMemo } from 'react'
import { useTranslation } from "react-i18next";
import useQueryParams from "../../hooks/useQueryParams";
import useUserData from "../../hooks/user/useUserData";
import moment from "moment";
import 'moment/locale/el'
import useUserAction from "../../hooks/user/useUserAction";
import './main.css';
import UnauthenticatedRouter from "../../routers/unauthenticatedRouter";
import Content from "./content";
import { Capacitor } from '@capacitor/core';
import Header from '../../thinkPlus/components/elements/Header';
import { useLocation } from "react-router";
import { useMediaQuery } from "@mui/material";
import AuthBackgroundImage from "../../../src/assets/images/components/authBackgroundImage"

const Main = () => {
	const { i18n } = useTranslation()
	const queryParams = useQueryParams()
	const urlLanguage = queryParams.get('lang')
	const { getUserPermissions, setUserLanguage } = useUserAction()
	const { isLoggedIn, language, alterPasswordOnLogin, fastLoginOtpVerified } = useUserData()
	const platform = Capacitor.getPlatform()
	
	const languageToSet = useMemo(() => (
			urlLanguage && (urlLanguage === 'el' || urlLanguage === 'en') ? urlLanguage : language),
		[language, urlLanguage])
	
	useEffect(() => {
		if (urlLanguage) {
			setUserLanguage(languageToSet)
		}
	}, [languageToSet, setUserLanguage, urlLanguage])
	
	useEffect(() => {
		moment.locale(languageToSet);
		i18n.changeLanguage(languageToSet)
	}, [i18n, language, languageToSet])
	
	useEffect(() => {
		if (isLoggedIn) {
			getUserPermissions()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getUserPermissions, isLoggedIn])
	
	useEffect(() => {
		
		if (!Capacitor.isNativePlatform() && window.location.hostname === 'app.ims-fc.gr') {
			const script = document.createElement('script');
			script.id = 'cookieyes'
			script.src = "https://cdn-cookieyes.com/client_data/65bac3fd8ce57dbbb64e6296/script.js";
			document.body.appendChild(script);
			
			return () => {
				document.body.removeChild(script);
			}
		}
	}, []);
	
	const location = useLocation();
	const pageClass = location.pathname.replace(/\//g, '-').substring(1);

	const matchUpSM = useMediaQuery((theme) => theme.breakpoints.up('sm'));
	if (!isLoggedIn || (isLoggedIn && alterPasswordOnLogin)) return (
		<>
			<div className={`page-${pageClass}`}>
				{((location.pathname !== '/') || ((location.pathname == '/' && !matchUpSM) && (location.pathname == '/' && matchUpSM))) &&
					<AuthBackgroundImage/>}
				{
					(
						(location.pathname !== '/signup' &&
							location.pathname !== '/reset-pass' &&
							location.pathname !== '/login' &&
							location.pathname !== '/fast-login' &&
							(!location.pathname.startsWith('/loans/application') || fastLoginOtpVerified) &&
							location.pathname !== '/'
						)
						||
						(location.pathname === '/' && !Capacitor.isNativePlatform())
					) &&
					<Header/>
				}
				<UnauthenticatedRouter/>
			</div>
		</>
	)
	return <Content/>
}

export default Main